import { constants } from "@/constants";
import Redirect from "@/services/redirect";

const OFFER_WINDOW_STORAGE_PREFIX = "confirmation_offer_start_";

function readStoredStartMs(orderId) {
  if (!orderId) {
    return null;
  }

  try {
    const stored = sessionStorage.getItem(
      `${OFFER_WINDOW_STORAGE_PREFIX}${orderId}`,
    );
    if (!stored) {
      return null;
    }

    const parsed = Number(stored);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

function writeStoredStartMs(orderId, startMs) {
  if (!orderId || !Number.isFinite(startMs)) {
    return;
  }

  try {
    sessionStorage.setItem(
      `${OFFER_WINDOW_STORAGE_PREFIX}${orderId}`,
      String(startMs),
    );
  } catch {
    /* storage unavailable */
  }
}

export function stampConfirmationOfferWindow(paramPlus = {}) {
  if (!paramPlus.countdownStartTimeMs) {
    paramPlus.countdownStartTimeMs = Date.now();
  }

  return paramPlus;
}

export function getConfirmationOfferWindowStartMs(orderId) {
  if (!orderId) {
    return null;
  }

  const paramPlus = Redirect.getParamPlusData() || {};
  if (
    paramPlus.orderId === orderId &&
    Number.isFinite(Number(paramPlus.countdownStartTimeMs))
  ) {
    return Number(paramPlus.countdownStartTimeMs);
  }

  return readStoredStartMs(orderId);
}

export function ensureConfirmationOfferWindowStart(orderId) {
  const existingStartMs = getConfirmationOfferWindowStartMs(orderId);
  if (existingStartMs) {
    return existingStartMs;
  }

  const startMs = Date.now();
  writeStoredStartMs(orderId, startMs);

  const paramPlus = Redirect.getParamPlusData() || {};
  if (paramPlus.orderId === orderId || !paramPlus.orderId) {
    localStorage.setItem(
      constants.PARAM_PLUS,
      JSON.stringify(
        stampConfirmationOfferWindow({
          ...paramPlus,
          orderId: orderId || paramPlus.orderId,
        }),
      ),
    );
  }

  return startMs;
}

export function isConfirmationOfferWindowExpired(orderId, now = Date.now()) {
  const startMs = getConfirmationOfferWindowStartMs(orderId);
  if (!startMs) {
    return false;
  }

  return now - startMs >= constants.CONFIRMATION_OFFER_WINDOW_MS;
}

export function getConfirmationOfferWindowRemainingMs(
  orderId,
  now = Date.now(),
) {
  const startMs = getConfirmationOfferWindowStartMs(orderId);
  if (!startMs) {
    return constants.CONFIRMATION_OFFER_WINDOW_MS;
  }

  return Math.max(0, constants.CONFIRMATION_OFFER_WINDOW_MS - (now - startMs));
}
